module.exports = __webpack_public_path__ + "img/ga.70187071.svg";